import React, {useEffect, useContext} from 'react';
import { Box, Button, Stack, TableCell, TextField, Typography, IconButton, Dialog, Backdrop, CircularProgress } from '@mui/material';
import {Context} from '../App';
import {API} from '../conf';
import SorTableCheckable from '../Components/ui/sortable-checkable';
import { Add, DeleteForever, Edit, InfoOutlined } from '@mui/icons-material';
import Header from '../Components/ui/Header';
// import ProjectForm from '../Components/forms/commande';
import moment from 'moment';

export default function Commandes() {
    const {updateConnect, region} = useContext(Context)
    const [load, setLoad] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const [action, setAction] = React.useState('');
    const [commandes, setCommandes] = React.useState([]);
    const [commande, setCommande] = React.useState();
    const [selectItems, setItems] = React.useState([]);
    const [searchInput, setSearchInput] = React.useState('');

    const table = [
        {header: "Titre", sortable: true, sortBy:(el)=>el.titre.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'50px'}}>{row.titre}</TableCell>},
        {header: "Statut", sortable: true, sortBy:(el)=>el.description.toLowerCase(), row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'200px'}}>{row.statut}</TableCell>},
        {header: "Type", sortable: true, sortBy:(el)=>el.type, row: (row, index)=><TableCell key={index} style={{textTransform:'capitalize', minWidth:'200px'}}>{row.type}</TableCell>},
        {header: "Période", sortable: true, sortBy:(el)=>new Date(el.dateDebut).getTime(), row: (row, index)=><TableCell key={index} sx={{minWidth:'200px', textAlign:'center'}}>{moment(row.dateDebut).format('DD/MM/yyy')+' - '+moment(row.dateFin).format('DD/MM/yyyy')}</TableCell>},
        {header: "Montant", sortable: true, sortBy:(el)=>el.montant, row: (row, index)=><TableCell key={index} style={{minWidth:'50px'}}>{row.montant?.toFixed(2)}</TableCell>},
        {header: "Montant collecté", sortable: true, sortBy:(el)=>el.montantCollecte, row: (row, index)=><TableCell key={index} style={{minWidth:'50px'}}>{row.montantCollecte?.toFixed(2)}</TableCell>},
        {header: "Organisateur", sortable: true, sortBy:(el)=>el.organisateur.toLowerCase(), row: (row, index)=><TableCell key={index} style={{minWidth:'200px', textTransform:'capitalize'}}>{row.organisateur}</TableCell>},
        {header: "", sortable: false, row: (row, index)=><TableCell key={index} sx={{minWidth:'180px', textAlign:'end'}} >
            <IconButton aria-label="informations complémentaires" onClick={()=>{setCommande(row); manage_dialog(true, 'info')}}><InfoOutlined fontSize="small"/></IconButton>
            <IconButton aria-label="supprimer" onClick={()=>{setCommande(row); manage_dialog(true, 'delete')}}><DeleteForever fontSize="small"/></IconButton>
            <IconButton aria-label="modifier" onClick={()=>{setCommande(row); manage_dialog(true, 'edit')}}><Edit fontSize="small"/></IconButton>
        </TableCell>}
    ]

    function normalize(str) {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/[^a-z0-9\s-.€]/gi,'').toLowerCase()
    }

    function get_searchable(item) {
        return item.titre+' '+item.description+' '+item.organisateur
    }

    function searchFilter(a, b) {
        return normalize(get_searchable(a)).includes(normalize(b))
    }

    function manage_dialog(status, action='') {
        setOpen(status)
        setAction(action)
        if(!status) {
            setCommande()
        }
    }

    async function showResult(result) {
        manage_dialog(true, result ? 'success' : 'echec')
        await new Promise(resolve => setTimeout(resolve, 3000))
        manage_dialog(false)
    }

    useEffect(() => {
        const query = new URLSearchParams({region}).toString();

        fetch(API.concat('/commandes?'+query), {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token')
            }
        }).then(async response => {
            const token = response.headers.get('x-auth-token');
            if (response.status === 401) {
                sessionStorage.clear();
                updateConnect(false);
            } else {
                if (token && token !== sessionStorage.getItem('token') && token !== '') {
                    sessionStorage.setItem('token', response.headers.get('x-auth-token'));
                }
                if (response.status === 200) {
                    const json = await response.json();
                    setCommandes(json);
                }
            }
        }).catch(error => {
            console.error("Error fetching commandes:", error);
        }).finally(() => {
            setLoad(false);
        });
    }, []);

    return(
        <Box display='flex' flexDirection='column' flex={1} >
            <Header/>
            <Box flex={1} display='flex' flexDirection='column' sx={{padding:2}}>
                <Typography variant='h4' marginBlock={3} align='center'>
                    Gestionnaire de commandes
                </Typography>

                <Stack direction="row" spacing={2} marginBottom={1.5} alignItems='center' justifyContent={'space-between'}>
                    <TextField value={searchInput} onChange={(e)=>setSearchInput(e.target.value)} label="Rechercher une commande ..." variant="outlined" size="small" sx={{width:'60%'}}/>
                    {/* <Button variant="contained" color="primary" onClick={()=>manage_dialog(true, 'add')} startIcon={<Add/>}>
                        Nouveau
                    </Button> */}
                </Stack>

                <SorTableCheckable {...{data:commandes.filter(reg=>searchFilter(reg, searchInput)),table, selectItems, setItems, rowsPerPage:25, rowsPerPageOptions:[25,50,100]}}/>
            </Box>

            {/* <Dialog {...{open, onClose:()=>manage_dialog(false), maxWidth:'md', fullWidth:true}}>
                {action === 'add' && <ProjectForm {...{close:()=>manage_dialog(false), showResult, setCommandes}}/>}
                {action === 'edit' && <ProjectForm {...{close:()=>manage_dialog(false), showResult, setCommandes, commande}}/>}
            </Dialog> */}

            <Backdrop open={load}><CircularProgress/></Backdrop>
        </Box>
    )
}

